import { actionTypes } from "./constants";

export const initialState = {
    data: null,  
    previousRequestSource: null,
    fetching: false 
}

export const budgetEffectivenessReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_BUDGET_EFFECTIVENESS_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_BUDGET_EFFECTIVENESS_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_BUDGET_EFFECTIVENESS_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 